<template>
  <div>
    <Header />
    <div class="ui hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui grid stackable two column">
      <div class="column">
        <Personal />
        <Technologies />
        <Awards />
      </div>
      <div class="column">
        <Education />
        <Career />
      </div>
    </div>
    <div class="ui clearing hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui divider"></div>
    <div class="ui hidden divider"></div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
import Personal from "@/components/Personal";
import Technologies from "@/components/Technologies";
import Education from "@/components/Education";
import Awards from "@/components/Awards";
import Career from "@/components/Career";

export default {
  components: {
    Header,
    Footer,
    Personal,
    Technologies,
    Education,
    Awards,
    Career
  }
};
</script>
